function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useMemo, useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { useSearchkitVariables } from '@searchkit/client';
import SearchPage from '../SearchPage';
function Query(_ref) {
  var query = _ref.query,
    useRouting = _ref.useRouting,
    children = _ref.children;
  var graphQuery = useMemo(function () {
    if (typeof query === 'string') {
      return gql(query);
    } else {
      return query;
    }
  }, [query]);
  var variables = useSearchkitVariables();
  var _useQuery = useQuery(graphQuery, {
      variables: variables
    }),
    data = _useQuery.data,
    loading = _useQuery.loading;

  // In between searches, Searchkit will empty it's results, resulting
  // in a re-render with an empty screen. Use a local state to prevent this.
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    dataLoaded = _useState2[0],
    setDataLoaded = _useState2[1];
  useEffect(function () {
    if (data) {
      setDataLoaded(data);
    }
  }, [data]);
  if (!useRouting) {
    return /*#__PURE__*/React.createElement("div", null, children(dataLoaded, loading));
  }
  return /*#__PURE__*/React.createElement(SearchPage, null, children(dataLoaded, loading));
}
export default Query;